import { render, staticRenderFns } from "./MerchantManage.vue?vue&type=template&id=533ba997&scoped=true"
import script from "./MerchantManage.vue?vue&type=script&lang=js"
export * from "./MerchantManage.vue?vue&type=script&lang=js"
import style0 from "./MerchantManage.vue?vue&type=style&index=0&id=533ba997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ba997",
  null
  
)

export default component.exports